import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Project} from '../../models/project';
import {ZoomDialogComponent} from "../../../builder/zoom-dialog/zoom-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {PartDisplayService} from "../../services/part-display.service";

@Component({
    selector: 'mbnm-basic-merch',
    templateUrl: './basic-merch.component.html',
    styleUrls: ['./basic-merch.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BasicMerchComponent implements OnInit {

  constructor(public dialog: MatDialog, private partDisplay: PartDisplayService) { }

  @Input()
  project: Project;

  @Input()
  projectPropertyName: string;

  @Input()
  imageUrl: string;

  @Input()
  enlargedImageUrl: string;

  @Input()
  title: string;

  @Output()
  backPressed = new EventEmitter();

  public projectProperty: any;

  ngOnInit() {
    this.projectProperty = this.projectPropertyName ? this.project[this.projectPropertyName] : null;
    this.title = this.projectProperty ? this.partDisplay.description(this.projectProperty) : this.title;
  }

  openZoomDialog() {
    if (this.enlargedImageUrl) {
      const dialogRef = this.dialog.open(ZoomDialogComponent);
      dialogRef.componentInstance.imageUrl = this.enlargedImageUrl;
    }
  }

  backButtonClicked() {
    this.backPressed.emit();
  }
}
